export const courses = [
  { id: 1, name_en: "Android Developer Fundamentals", name_ar: "أساسيات تطوير أندرويد" },
  { id: 2, name_en: "Artificial Intelligence Fundamentals", name_ar: "أساسيات الذكاء الاصطناعي" },
  { id: 3, name_en: "Data Analysis Fundamentals", name_ar: "أساسيات تحليل البيانات" },
  { id: 4, name_en: "Programming Fundamentals", name_ar: "أساسيات البرمجة" },
];

// Nationalities
export const NATIONALITIES = {
  JORDAN: 1,
  SYRIA: 2,
  OTHER: 3, // Added Other
};

// Age ranges
export const AGE_RANGE = {
  TEEN: 1, // 13-17
  YOUNG: 2, // 18-34
  ADULT: 3, // 34+
};

// Gender
export const GENDER = {
  MALE: 1,
  FEMALE: 2,
};

// How did you hear about us
export const HEARD_ABOUT_US = {
  LINKEDIN: 1,
  FACEBOOK: 2,
  SEARCH_ENGINE: 3,
  JOCODES_HELLOGATE_PROGRAM_SOCIAL_MEDIA: 4,
  FRIEND_INVITATION: 5,
  CROWN_PRINCE_FOUNDATION_CPF: 6,
  MINISTRY_OF_DIGITAL_ECONOMY_AND_ENTREPRENEURSHIP_MODEE: 7,
  FUTURE_STATIONS: 8,
  OTHER: 9,
};

// User / Student types
export const TYPES = {
  SCHOOL: 1,
  UNIVERSITY: 2,
  OTHER: 3,
  SCHOOLTEACHER: 4,
};

export const UNIVERSITIES = [
  { id: 1, name: "University of Jordan" },
  { id: 2, name: "Al-Balqaa Applied University" },
  { id: 3, name: "Hashemite University" },
  { id: 4, name: "Yarmouk University" },
  { id: 5, name: "Mutah University" },
  { id: 6, name: "German Jordan University" },
  { id: 7, name: "Al Al-Bayt University" },
  { id: 8, name: "Tafilah Technical University" },
  { id: 9, name: "Al-Hussein Bin Talal University" },
  { id: 10, name: "Jordan University for Science and Technology" },
  { id: 11, name: "Petra University" },
  { id: 12, name: "Zarqa University" },
  { id: 13, name: "Other" },
];

export const FIELDS = [
  { id: 1, name: "Agriculture" },
  { id: 2, name: "Arts" },
  { id: 3, name: "Business" },
  { id: 4, name: "Computer Science and IT" },
  { id: 5, name: "Education" },
  { id: 6, name: "Engineering" },
  { id: 7, name: "Humanities" },
  { id: 8, name: "Law" },
  { id: 9, name: "Medicine" },
  { id: 10, name: "Natural Science" },
  { id: 11, name: "Social Science" },
  { id: 12, name: "Other" },
];

export const EDUCATION_LEVELS = [
  { id: 1, name: "High School" },
  { id: 2, name: "Bachelor's Degree" },
  { id: 3, name: "Master's Degree" },
  { id: 4, name: "PhD" },
  { id: 5, name: "Other" },
];

export const EMPLOYMENT_STATUS = [
  { id: 1, name: "Employed" },
  { id: 2, name: "Unemployed" },
  { id: 3, name: "Other" },
];

export const SECTORS = [
  { id: 1, name: "Private" },
  { id: 2, name: "Public" },
];
